export const generateCaptcha = () => {
  const randomchar =
    "ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnopqrstuvwxyz123456789";
  var uniquechar = "";
  for (let i = 1; i < 5; i++) {
    uniquechar += randomchar.charAt(Math.random() * randomchar.length);
  }
  return uniquechar;
};
